module.exports = __webpack_public_path__ + "img/linkedin.e207e98e.svg";